import { useRef, useEffect, useCallback, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { Link } from "react-router-dom";
import { selectFavoriteTeam } from "../redux/data/dataActions";
import { setTabSelected, setIsMobileView, setWindowSize, setSelectFavTeamModalOpen } from "../redux/data/dataSlice";
import NBATeamsList from "../utils/teamData";
import TeamPickerModal from "./header/teamPickerModal";
import "../assets/css/profile-header.css";

function Header() {
    const queryParams = new URLSearchParams(window.location.search);
    const webview = queryParams.get("webview");
    const memberhubHeaderRef = useRef();
    const dispatch = useDispatch();
    const selectFavTeamModalOpen = useSelector(state => state.data.selectFavTeamModalOpen);
    const tabSelected = useSelector(state => state.data.tabSelected);
    const memberSince = useSelector(state => state.data.memberSince);
    const userName = useSelector(state => state.data.userName);
    const userGuid = useSelector(state => state.data.userGuid);
    const favoriteTeams = useSelector(state => state.data.favoriteTeams);
    const [favTeam, setFavTeam] = useState(null);
    const [userIsLoggedIn, setUserIsLoggedIn] = useState(false);
    const noNameDefaultText = "Welcome Back";

    const submitFavTeam = team => {
        if (team) {
            dispatch(selectFavoriteTeam(favoriteTeams, team));
            dispatch(setSelectFavTeamModalOpen(false));
            setFavTeam(team);
        }
    };

    const toggleTeamPickerModal = () => {
        if (!selectFavTeamModalOpen) {
            console.info("Opening fav team picker modal");

            if (window._satellite && window._satellite.track) {
                window._satellite.track("modal-display", {
                    modalName: "nba:membership-hub:favorite-team",
                    contentTitle: "SELECT YOUR FAVORITE TEAM",
                });
            }
            dispatch(setSelectFavTeamModalOpen(true));
        } else {
            dispatch(setSelectFavTeamModalOpen(false));
        }
    };

    const getHeaderText = () => {
        if (userName && userName.givenName) {
            const emptyStringCheck = userName.givenName.replaceAll(' ', '');

            if (emptyStringCheck !== '') {
                return userName.givenName;
            }
        }

        return noNameDefaultText;
    };

    const handleResize = useCallback(() => {
        if (typeof window !== 'undefined') {
            if (window.innerWidth < 767) {
                dispatch(setIsMobileView(true));
                dispatch(setWindowSize("small"));
            } else {
                dispatch(setIsMobileView(false));
                if (window.innerWidth < 1015) {
                    dispatch(setWindowSize("medium"));
                } else {
                    dispatch(setWindowSize("large"));
                }
            }
        } else {
            dispatch(setIsMobileView(false));
            dispatch(setWindowSize("large"));
        }
    }, [dispatch]);

    useEffect(() => {
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [handleResize]);

    useEffect(() => {
        console.log("query webview:", webview);

        if (webview && webview.toLowerCase() === "true") {
            const nbaNav = document.getElementById("nba-nav");
            if (nbaNav) {
                nbaNav.style.display = "none";
            }
            const nbaFooter = document.getElementById("nba-footer");
            if (nbaFooter) {
                nbaFooter.style.display = "none";
            }
            const memberhubHeader = memberhubHeaderRef.current;
            if (memberhubHeader) {
                memberhubHeader.style.marginTop = "0px";
            }
        }
    }, [webview]);

    useEffect(() => {
        if (userGuid && window && window.digitalData && window.digitalData.user) {
            window.digitalData.user.userID = userGuid;
            window.digitalData.user.authenticationType = "NBA CIAM";
            window.digitalData.user.authenticationProvider = "NBA CIAM";
        }
        if (favoriteTeams && favoriteTeams.length > 0) {
            const fav = favoriteTeams.find(team => team.favorited);
            if (fav) {
                setFavTeam(NBATeamsList.find(team => team.tricode === fav.teamTriCode.toUpperCase()));
            } else {
                setFavTeam(null);
            }
        } else {
            setFavTeam(null);
        }
    }, [favTeam, favoriteTeams, userGuid, userName]);

    useEffect(() => {
        const isLoggedIn = localStorage.getItem('isLoggedIn');
        if (isLoggedIn === "1") {
            setUserIsLoggedIn(true);
        }
    }, [dispatch, tabSelected]);

    return (
    <>
        <div className={`memberhub-header ${tabSelected === "play" ? "no-show" : ""}`} ref={memberhubHeaderRef}>
            { userIsLoggedIn &&
                <div id="profile-header" className={favTeam ? favTeam.tricode.toLowerCase() : 'no-team'}>
                    <div id="overview-member">
                        <div id="overview-nbaid-logo"></div>
                        <div id="overview-member-info">
                            <p id="overview-header-user-name">
                                { getHeaderText() }
                            </p>
                            <p id="overview-team-title">A proud {favTeam && favTeam.name !== null ? favTeam.name : 'NBA'} fan</p>
                        </div>
                        {favTeam === null &&
                            <a className="mobile-select-fav-team" onClick={() => toggleTeamPickerModal()} data-track="click" data-id="nba:membership-hub:choose-favorite-team:button"
                            data-type="button" data-text="Select your favorite team" data-section="hero">
                                Choose Your Favorite Team
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g id="icon-right">
                                    <path id="vector" fillRule="evenodd" clipRule="evenodd"
                                        d="M6.47139 2.19531L5.52858 3.13812L10.3905 8.00005L5.52858 12.862L6.47139 13.8048L12.2761 8.00005L6.47139 2.19531Z"
                                        fill="white"/>
                                    </g>
                                </svg>
                            </a>
                        }
                        <div className="member-since-wallet-container">
                            <div id="overview-member-since">
                                <p id="overview-header-since-title">Member Since</p>
                                <p id="overview-header-since-value">
                                    {memberSince && `${new Intl.DateTimeFormat("en-US", { month: "long" }).format(memberSince * 1000)}
                                    ${new Date(memberSince * 1000).getFullYear()}`}
                                </p>
                            </div>
                            <Link id="mobile-member-card-btn" to={{ pathname: "/wallet", search: window.location.search }}
                                data-track="click" data-id="nba:membership-hub:member-card:button" data-type="button" data-text="member wallet" data-section="Hero"
                                onClick={(e) => {
                                    e.target.scrollIntoView(false);
                                    dispatch(setTabSelected("wallet"));
                                }}>
                                <svg xmlns="http://www.w3.org/2000/svg" enableBackground="new 0 0 24 24" height="36px" viewBox="0 0 24 24" width="36px" fill="#FFFFFF"><g><rect fill="none" height="24" width="24"/></g><path d="M15,21h-2v-2h2V21z M13,14h-2v5h2V14z M21,12h-2v4h2V12z M19,10h-2v2h2V10z M7,12H5v2h2V12z M5,10H3v2h2V10z M12,5h2V3h-2V5 z M4.5,4.5v3h3v-3H4.5z M9,9H3V3h6V9z M4.5,16.5v3h3v-3H4.5z M9,21H3v-6h6V21z M16.5,4.5v3h3v-3H16.5z M21,9h-6V3h6V9z M19,19v-3 l-4,0v2h2v3h4v-2H19z M17,12l-4,0v2h4V12z M13,10H7v2h2v2h2v-2h2V10z M14,9V7h-2V5h-2v4L14,9z M6.75,5.25h-1.5v1.5h1.5V5.25z M6.75,17.25h-1.5v1.5h1.5V17.25z M18.75,5.25h-1.5v1.5h1.5V5.25z"/></svg>
                                Member Card
                            </Link>
                        </div>
                    </div>
                    <div id="overview-edit">
                    {favTeam === null &&
                        <a id="edit-profile-btn" onClick={() => toggleTeamPickerModal()} data-track="click" data-id="nba:membership-hub:choose-favorite-team:button"
                        data-type="button" data-text="Select your favorite team" data-section="hero">Choose Your Favorite Team</a>
                    }
                        <Link id="member-card-btn" to={{ pathname: "/wallet", search: window.location.search }}
                            data-track="click" data-id="nba:membership-hub:member-card:button" data-type="button" data-text="member wallet" data-section="Hero"
                            onClick={(e) => {
                                e.target.scrollIntoView(false);
                                dispatch(setTabSelected("wallet"));
                            }}>
                            <svg xmlns="http://www.w3.org/2000/svg" enableBackground="new 0 0 24 24" height="36px" viewBox="0 0 24 24" width="36px" fill="#FFFFFF"><g><rect fill="none" height="24" width="24"/></g><path d="M15,21h-2v-2h2V21z M13,14h-2v5h2V14z M21,12h-2v4h2V12z M19,10h-2v2h2V10z M7,12H5v2h2V12z M5,10H3v2h2V10z M12,5h2V3h-2V5 z M4.5,4.5v3h3v-3H4.5z M9,9H3V3h6V9z M4.5,16.5v3h3v-3H4.5z M9,21H3v-6h6V21z M16.5,4.5v3h3v-3H16.5z M21,9h-6V3h6V9z M19,19v-3 l-4,0v2h2v3h4v-2H19z M17,12l-4,0v2h4V12z M13,10H7v2h2v2h2v-2h2V10z M14,9V7h-2V5h-2v4L14,9z M6.75,5.25h-1.5v1.5h1.5V5.25z M6.75,17.25h-1.5v1.5h1.5V17.25z M18.75,5.25h-1.5v1.5h1.5V5.25z"/></svg>
                            Member Card
                        </Link>
                    </div>
                </div>
            }
        </div>
        <div id="nav-tab-container" className={tabSelected === "play" ? "no-show" : ""}>
            { !userIsLoggedIn &&
                <div id="mobile-noauth-header">
                    <div id="noauth-nbaid-logo"></div>
                </div>
            }
            <div id="id-nav">
                <div className={`id-nav-tab ${tabSelected === "overview" ? 'selected' : ''}`}>
                    <Link to={{ pathname: "/overview", search: window.location.search }}
                        onClick={(e) => {
                            e.target.scrollIntoView(false);
                            dispatch(setTabSelected("overview"));
                        }}>
                        Overview
                    </Link>
                </div>
                <div className={`id-nav-tab ${tabSelected === "challenges" ? 'selected' : ''}`}>
                    <Link to={{ pathname: "/challenges", search: window.location.search }}
                        onClick={(e) => {
                            e.target.scrollIntoView(false);
                            dispatch(setTabSelected("challenges")); }}>
                        Challenges
                    </Link>
                </div>
                <div className={`id-nav-tab ${tabSelected === "voting" ? 'selected' : ''}`}>
                    <Link to={{ pathname: "/voting", search: window.location.search }}
                        onClick={(e) => {
                            e.target.scrollIntoView(false);
                            dispatch(setTabSelected("voting"));
                        }}>
                        Voting
                    </Link>
                </div>
                <div className={`id-nav-tab ${tabSelected === "badges" ? 'selected' : ''}`}>
                    <Link to={{ pathname: "/badges", search: window.location.search }}
                        onClick={(e) => {
                            e.target.scrollIntoView(false);
                            dispatch(setTabSelected("badges"));
                        }}>
                        Badges
                    </Link>
                </div>
                <div className={`id-nav-tab ${tabSelected === "benefits" ? 'selected' : ''}`}>
                    <Link to={{ pathname: "/benefits", search: window.location.search }}
                        onClick={(e) => {
                            e.target.scrollIntoView(false);
                            dispatch(setTabSelected("benefits"));
                        }}>
                        Benefits
                    </Link>
                </div>
            </div>
        </div>
        {selectFavTeamModalOpen && <TeamPickerModal closeModal={() => toggleTeamPickerModal()} submit={team => submitFavTeam(team)} />}
    </>
    );
}

export default Header;
